import script from "./control-overlay-base.vue?vue&type=script&setup=true&lang=js"
export * from "./control-overlay-base.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__